import script from "./Paint.vue?vue&type=script&setup=true&lang=js"
export * from "./Paint.vue?vue&type=script&setup=true&lang=js"

import "./Paint.vue?vue&type=style&index=0&id=8eef9cbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8eef9cbe"]])

export default __exports__